export default "<p *ngIf=\"showAgricultureText\">{{ 'confirmation.confirmationAgriculture' | translate }}</p>\n"